
// export const API_URL = 'https://flc-almacen.org/api'
export const API_URL = 'https://dev.flc-almacen.org/api'
// export const API_URL = 'http://localhost:30000/api'
